
var SitemapPageMsg = 'This is the site map for the application. It shows links to all pages of the application. You may access any page using links given here. However, login is required to access some pages.  Use tab to go to the next field.';
var speakValue = "";
var inputValue = "";
var inputplaceholder = "";
var typingTimer;                //timer identifier
var doneTypingInterval = 1800;  //time in ms
var tabKeyCode = 9;
var enterKeyCode = 13;
var DisplayUserInput = "";
var speakValueOnKeyPress = "";

function SitemapPageLoad() {
  //debugger;
  responsiveVoice.cancel();
  if ($('#hidVoiceOnOff').val() == 'ON') {
    responsiveVoice.speak(SitemapPageMsg, ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
  }
  SitemapCaption(SitemapPageMsg, tabKeyCode);
}

/*------------------------------------------------------------------
      Common Function for Caption.
------------------------------------------------------------------*/
function SitemapCaption(newCaptionInput, keyCode) {
  //debugger;
  if (keyCode == tabKeyCode) {
    var oldCaption = "";
    var newCaption = "";
    oldCaption = document.getElementById('txtCaptions').value;
    newCaption = oldCaption + "\n" + newCaptionInput;
    if (oldCaption == "") {
      newCaption = newCaptionInput;
    }
    if (newCaptionInput != "") {
      document.getElementById("txtCaptions").value = newCaption;
      var $textCaptionArea = $('#txtCaptions');
      $textCaptionArea.scrollTop($textCaptionArea[0].scrollHeight);
    }
  }
  if (keyCode == enterKeyCode) {
    var oldCaption = "";
    var newCaption = "";
    oldCaption = document.getElementById('txtCaptions').value;
    newCaption = oldCaption + "\n" + newCaptionInput;
    if (oldCaption == "") {
      newCaption = newCaptionInput;
    }
    if (newCaptionInput != "") {
      document.getElementById("txtCaptions").value = newCaption;
      var $textCaptionArea = $('#txtCaptions');
      $textCaptionArea.scrollTop($textCaptionArea[0].scrollHeight);
    }
  }
}

/*------------------------------------------------------------------
      Common Function for speak which is connected with registration component.ts file.
------------------------------------------------------------------*/
function SitemapresponsiveVoiceSpeak(inputplaceholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key) {
  debugger;
  if (keyCode == enterKeyCode) {
    responsiveVoice.cancel();
    if (eventId == "lblHome") {
      document.getElementById("lblHome").click();
      return;
    }
    else if (eventId == "lblhelp") {
      document.getElementById("lblhelp").click();
      return;
    }
    else if (eventId == "lblLogin") {
      document.getElementById("lblLogin").click();
      return;
    }
    else if (eventId == "lblAbout") {
      document.getElementById("lblAbout").click();
      return;
    }
    //else if (eventId == "lblAbout") {
    //  document.getElementById("lblAbout").click();
    //  return;
    //}
    else if (eventId == "lblBrowseObligors") {
      document.getElementById("lblBrowseObligors").click();
      return;
    }
    else if (eventId == "lblWebcast") {
      document.getElementById("lblWebcast").click();
      return;
    }
    else if (eventId == "Accessingwebcasts") {
      document.getElementById("Accessingwebcasts").click();
      return;
    }
    else if (eventId == "lblCurrentIssues") {
      document.getElementById("lblCurrentIssues").click();
      return;
    }
    else if (eventId == "lblIssuesNoLongerOutstanding") {
      document.getElementById("lblIssuesNoLongerOutstanding").click();
      return;
    }
    else if (eventId == "lblAuditedFinancialStatements") {
      document.getElementById("lblAuditedFinancialStatements").click();
      return;
    }
    else if (eventId == "lblAnnualFinancialInformation") {
      document.getElementById("lblAnnualFinancialInformation").click();
      return;
    }
    else if (eventId == "lblBudgets") {
      document.getElementById("lblBudgets").click();
      return;
    }
    else if (eventId == "lblInterimFinancial") {
      document.getElementById("lblInterimFinancial").click();
      return;
    }
    else if (eventId == "lblFailure") {
      document.getElementById("lblFailure").click();
      return;
    }
    else if (eventId == "lblOtherFinancial") {
      document.getElementById("lblOtherFinancial").click();
      return;
    }
    else if (eventId == "lblEventNotices") {
      document.getElementById("lblEventNotices").click();
      return;
    }
    else if (eventId == "lblOtherEventbased") {
      document.getElementById("lblOtherEventbased").click();
      return;
    }
    else if (eventId == "lblRatingChange") {
      document.getElementById("lblRatingChange").click();
      return;
    }
    else if (eventId == "lblUnscheduled") {
      document.getElementById("lblUnscheduled").click();
      return;
    }
    else if (eventId == "lblBondCalls") {
      document.getElementById("lblBondCalls").click();
      return;
    }
    else if (eventId == "lblQA") {
      document.getElementById("lblQA").click();
      return;
    }
    else if (eventId == "lblQAForum") {
      document.getElementById("lblQAForum").click();
      return;
    }
    else if (eventId == "lblAsk") {
      document.getElementById("lblAsk").click();
      return;
    }
    else if (eventId == "lblDACForIssuers") {
      document.getElementById("lblDACForIssuers").click();
      return;
    }
    else if (eventId == "lblDACForInvestors") {
      document.getElementById("lblDACForInvestors").click();
      return;
    }
    else if (eventId == "lblDMCA") {
      document.getElementById("lblDMCA").click();
      return;
    }
    else if (eventId == "lblLegalInformation") {
      document.getElementById("lblLegalInformation").click();
      return;
    }
    else if (eventId == "SkipMainContent") {
      SitemapspeakForAnchorTagControlType(innerText, title, keyCode);
    }
  }

  if (controlType == "text") {
    if (inputValue == "") {
      SitemapspeakForAnchorTagControlType(inputValue, inputplaceholder, keyCode);
    }
  }
  if (controlType == "textarea") {
    SitemapspeakForAnchorTagControlType(inputValue, keyCode);
  }
  debugger;
  if (eventId == "lblHome" || eventId == "lblhelp" || eventId == "lblLogin" || eventId == "lblAbout"
    || eventId == "liBrowseObligors" || eventId == "lblWebcast" || eventId == "lblOverview" || eventId == "lblCurrentIssues"
    || eventId == "lblIssuesNoLongerOutstanding" || eventId == "lblFilingHistory" || eventId == "lblDocumentCategories" || eventId == "lblAuditedFinancialStatements"
    || eventId == "lblAnnualFinancialInformation" || eventId == "lblBudgets" || eventId == "lblInterimFinancial" || eventId == "lblFailure"
    || eventId == "lblOtherFinancial"
    || eventId == "lblRatingChange" || eventId == "lblUnscheduled" || eventId == "lblBondCalls"
    || eventId == "lblQAForum" || eventId == "lblAsk" || eventId == "lblDACForIssuers" || eventId == "lblDACForInvestors"
    || eventId == "lblDMCA") {
    SitemapspeakForAnchorTagControlType(innerText, title, keyCode);
  }

  if (controlType == "textarea") {
    SitemapspeakForAnchorTagControlTypes(inputValue, keyCode);
  }
  if (eventId == "lblLegalInformation"

  ) {
    SitemapspeakForAnchorTagControlTypes(innerText, title, keyCode);
  }


  if (eventId == "lblSitemap") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Sitemap. Use tab to go to the first link.");
    }
    HelpCaption("Sitemap. Use tab to go to the first link.", keyCode);
    return;
  }

  if (eventId == "lblDocumentCategories") {
    responsiveVoice.cancel();
    //responsiveVoice.speak(innerText);
    HomeCaption(innerText, keyCode);
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak(innerText + '.' + "Use tab to go to the next link.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HomeCaption("Use tab to go to the next link.", keyCode);
  }

  if (eventId == "lblOtherEventbased") {
    responsiveVoice.cancel();
    //responsiveVoice.speak(innerText);
    HomeCaption(innerText, keyCode);
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak(innerText + '.' + "Use tab to go to the next link.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HomeCaption("Use tab to go to the next link.", keyCode);
  }

  if (eventId == "lblEventNotices") {
    responsiveVoice.cancel();
    //responsiveVoice.speak(innerText);
    HomeCaption(innerText, keyCode);
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak(innerText + '.' + "Use tab to go to the next link.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HomeCaption("Use tab to go to the next link.", keyCode);
  }

  if (eventId == "lblQA") {
    responsiveVoice.cancel();
    //responsiveVoice.speak(innerText);
    HomeCaption(innerText, keyCode);
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak(innerText + '.' + "Use tab to go to the next link.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HomeCaption("Use tab to go to the next link.", keyCode);
  }


}

/*------------------------------------------------------------------
      Common Function for anchor controls.
------------------------------------------------------------------*/
function SitemapspeakForAnchorTagControlType(innerText, title, keyCode) {
  //debugger;
  responsiveVoice.cancel();
  if ($('#hidVoiceOnOff').val() == 'ON') {
    if (innerText == 'A-') {
      responsiveVoice.speak("A. Minus", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    else {
      responsiveVoice.speak(innerText + ' ' + "Use Enter key to select this link or use tab to go to the next link.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
  }
  SitemapCaption(innerText, keyCode);
  //responsiveVoice.speak(title);
  SitemapCaption("Use Enter key to select this link or use tab to go to the next link.", keyCode);

}


function SitemapspeakForAnchorTagControlTypes(innerText, title, keyCode) {
  //debugger;
  responsiveVoice.cancel();
  if ($('#hidVoiceOnOff').val() == 'ON') {
    if (innerText == 'A-') {
      responsiveVoice.speak("A. Minus", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    else {
      responsiveVoice.speak(innerText + ' ' + "Use Enter key to select this link or use tab to go to the footer.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
  }
  SitemapCaption(innerText, keyCode);
  //responsiveVoice.speak(title);
  SitemapCaption("Use Enter key to select this link or use tab to go to the footer.", keyCode);

}

